import { render, staticRenderFns } from "./deleteEmployers.vue?vue&type=template&id=0d6a633e"
import script from "./deleteEmployers.vue?vue&type=script&lang=js"
export * from "./deleteEmployers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports